module.exports = __webpack_public_path__ + "static/hero-image-f4e7315552c25390827dd24af67f07c0.jpg";